module.exports = __webpack_public_path__ + "static/assets/14b94f87eb7db8322e8fc40c4d4b6ad2.svg";